import { XMLParser } from "fast-xml-parser";
import { addBearing, formatDate, formatTime } from "./baseParser";

/**
 * format specification (for v1.0, no change to v1.1 for the sections we care about) https://www.topografix.com/gpx_manual.asp#trkpt
 *
 * @returns a time sorted unique array of GPS records
 */
export function parseRawData(fileData) {
  const parser = new XMLParser({ ignoreAttributes: false });
  const json = parser.parse(fileData);

  const rows = json.gpx.trk.trkseg.trkpt.map((trkpt) => {
    const date = new Date(Date.parse(trkpt.time));
    return {
      sortingKey: date,
      dateTime: date,
      latitude: coordinateConvert(trkpt["@_lat"]),
      longitude: coordinateConvert(trkpt["@_lon"]),
      speed: convertSpeed(trkpt.speed) ?? "Unknown",
      dateDisplay: formatDate(date),
      timeDisplay: formatTime(date),
      dateSet: true,
    };
  });

  const sortedRows = rows.sort((a, b) => a.sortingKey - b.sortingKey);

  return addBearing(sortedRows);
}

//converting latitude/longitude from the given geometry string
function coordinateConvert(geom) {
  return parseFloat(geom).toFixed(6);
}

//converts speed from m/s to km/h
function convertSpeed(speed) {
  return speed != null ? `${(speed * 3.6).toFixed(0)} km/h` : null;
}
